<template>
  <vs-sidebar
    click-not-close
    hidden-background
    position-right
    v-model="active"
    class="items-no-padding department-edit">
    <div class="h-full">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div class="dialog-title">
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">

        <div class="px-6">
          <el-form
            :model="form"
            :rules="rules"
            hide-required-asterisk
            label-position="top"
            ref ="form"
          >
            <el-form-item
              label="审核结论"
              prop="name"
            >
              <vs-radio
                v-model="form.decision"
                vs-name="radios1"
                class="mar-right10"
                :vs-value="1"
              >通过</vs-radio>
              <vs-radio
                v-model="form.decision"
                vs-name="radios1"
                class=""
                :vs-value="2"
              >不通过</vs-radio>
            </el-form-item>
            <el-form-item
              v-if="form.decision == 2"
              label="拒绝原因"
              prop="rejectReason"
            >
              <el-select
                v-model="form.rejectReason"
                class="select-el"
                placeholder="请选择"
                multiple
              >
                <el-option
                  v-for="(item,index) in rejectReasonOption"
                  :label="item.value"
                  :key="index"
                  :value="item.value"
                >
                </el-option>
                <el-option
                  label="自定义"
                  value="自定义"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="form.rejectReason.includes('自定义')"
              prop="rejectReasonSelf"
            >
              <el-input
                class="textarea-el"
                type="textarea"
                v-model="form.rejectReasonSelf"
                maxlength="200"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item>
              <vs-button @click="submit" class="mar-right10" type="filled" color="primary">确认</vs-button>
              <vs-button @click="cancel" type="border"  color="primary">取消</vs-button>
            </el-form-item>
          </el-form>
        </div>
      </VuePerfectScrollbar>
    </div>
  </vs-sidebar>
</template>

<script>

  import { getDictListByType } from '@/api/user'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    export default {
      name: "auditDialog",
      props: {
        active: {
          type: Boolean,
          default: false
        },
      },
      components: {
        VuePerfectScrollbar,
      },
      data() {
        return {
          settings: {
            maxScrollbarLength : 60,
            wheelSpeed         : .60,
          },
          rejectReasonOption: [],
          form:{
            decision: 1,
            rejectReason: [],
            rejectReasonSelf: ''
          },
          rules:{
            rejectReason:[
              { required: true, message: '请选择', trigger: 'change' }
            ],
            rejectReasonSelf:[
              { required: true, message: '请选择', trigger: 'blur' }
            ],
          }
        }
      },
      created(){
        this.getDictList();
      },
      watch: {
        active(newValue){
          if(newValue){
            this.$refs.form.clearValidate();
          }
        }
      },
      computed: {
        title() {
          return '审核';
        }
      },
      methods: {
        getDictList(){
          getDictListByType({
            type : 'auditIdentifyRejectReason'
          }).then((res) => {
            console.log(res);
            this.rejectReasonOption = res.data;
          })
        },
        close(){
          this.reset();
          this.$emit('close')
        },
        reset(){
          this.form = {
            decision: 1,
            rejectReason: [],
            rejectReasonSelf: ''
          };
        },
        closeHandle() {
          this.close();
          this.$refs.form.resetFields();
        },
        cancel(){
          this.$refs.form.resetFields();
          this.close();
        },
        submit(){
            this.$refs.form.validate((valid) => {
              if(valid){
                // ajax
                let params = {
                   decision: this.form.decision,
                };
                if (this.form.rejectReason.includes('自定义')) {
                  params.rejectReason = this.deletedefined(this.form.rejectReason.join(';')+ ';' + this.form.rejectReasonSelf);
                }else {
                  params.rejectReason = this.form.rejectReason.join(';');
                }
                this.$emit('send-form', params);
                this.close();
              }else {

              }
            })
        },
        deletedefined(string){
          return string.replace('自定义;','');
        }
      },
    }
</script>

<style lang="scss">
  .department-edit {
    .vs-sidebar {
      position: fixed;
      z-index: 999;
      width: 360px;
      max-width: 90vw;
      // @apply shadow-lg;
      box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08);
    }
    .scroll-area--customizer {
      height: calc(100% - 5rem);
    }
    .el-select {
      width: 100%;
    }
  }


</style>
